// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4fa01f758839e6203426","655":"c63db2022a72495fc22e"}[chunkId] + ".js";
};